module.exports = __webpack_public_path__ + "static/media/applenav-shop2.0347b3a9.PNG";